'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest$0024$002dCertificate$002dOf$002dOrigin from "./app.data.-App-Document-Data-Create-Request$-Certificate-Of-Origin.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$() {
}
export { $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$ as $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$ };
$p = $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$() {
}
export { $h_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$ as $h_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$ };
$h_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$.prototype = $p;
$p.n = (function() {
  return "CertificateOfOrigin";
});
$p.bKc = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest$0024$002dCertificate$002dOf$002dOrigin.$c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin(x$0.e(0));
});
$p.U = (function(p) {
  return this.bKc(p);
});
var $d_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$, "app.data.AppDocumentDataCreateRequest$CertificateOfOrigin$", ({
  An: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$ as $d_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$ };
var $n_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$;
function $m_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$() {
  if ((!$n_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$)) {
    $n_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$ = new $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$();
  }
  return $n_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$;
}
export { $m_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$ as $m_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin$ };
//# sourceMappingURL=app.data.-App-Document-Data-Create-Request$-Certificate-Of-Origin$.js.map
